import React, { useState } from 'react';
import axios from 'axios';
import config from '../../config';
import './Auth.css';

function ForgotPasswordForm({ onToggleForm }) {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${config.API_BASE_URL}/auth/forgot-password`, {
        email
      });
      setMessage(response.data.message);
    } catch (error) {
      setError(error.response?.data?.error || 'Error processing request');
    }
  };

  return (
    <div className="auth-form">
      <h2>Reset Password</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        {error && <div className="auth-error">{error}</div>}
        {message && <div className="auth-success">{message}</div>}
        <button type="submit">Reset Password</button>
      </form>
      <div className="auth-links">
        <button className="link-button" onClick={() => onToggleForm('login')}>
          Back to Login
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordForm; 